import { DropdownMenuItem } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function DropdownMenuItemEmpty() {
  const { t } = useTranslation();
  return (
    <DropdownMenuItem>
      <div className="text-center justify-start text-neutrals-700 text-sm font-normal leading-tight">
        {t('domain.navigation.benachrichtigungen.empty')}
      </div>
    </DropdownMenuItem>
  );
}
